import { service } from '@/utils/request'

export default {
    getDataList(params) {
        return service({
            url: '/cloud/course/v1/admin/custom/table/list',
            method: 'get',
            params
        })
    },
    remove(params) {
        return service({
            url: '/cloud/course/v1/admin/custom/table/delete',
            method: 'post',
            params
        })
    },
    save(data) {
        return service({
            url: '/cloud/course/v1/admin/custom/table/save',
            method: 'post',
            data
        })
    },
    getDetail(params) {
        return service({
            url: '/cloud/course/v1/admin/custom/table/details',
            method: 'get',
            params
        })
    },
    update(data) {
        return service({
            url: '/cloud/course/v1/admin/custom/table/update',
            method: 'post',
            data
        })
    },
    exportExcel(params) {
        return service({
            url: '/cloud/course/v1/admin/custom/table/exportExcel',
			method: 'get',
            params,
			responseType: 'blob'
		})
    },
    open(params) {
        return service({
            url: '/cloud/course/v1/admin/custom/table/open',
            method: 'post',
            params
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/operateManage/signupform.js